<template lang="pug">
  .map-popup.map-popup-car
    div
      div.tooltip__head
        p(v-html="fields.name").title
        span(@click="close($event)").close.close--small.close--tooltip
      div.tooltip__body
        div(v-if="fields.signal").tooltip__body-item
          span.info.info--grey Сигнал:
          span.info {{fields.signal}}%
        div.tooltip__body-item
          span.info.info--grey Обновлено:
          span.info
            | {{fields.message_datetime ? fields.message_datetime : lastUpdate}}
        div.tooltip__body-item
        div.tooltip__body-item
          span.info.info--grey Широта и долгота:
          span.info {{fields.lat}}, {{fields.lng}}
        div(v-if="fields.direction").tooltip__body-item
          span.info.info--grey Направление:
          span.info {{fields.direction}}
        div(v-if="fields.textStatus").tooltip__body-item
          span.info.info--grey Статус:
          span.info {{fields.textStatus}}
        div(v-else-if="fields.textstatus").tooltip__body-item
          span.info.info--grey Статус:
          span.info {{fields.textstatus}}
        div(v-if="fields.speed").tooltip__body-item
          span.info.info--grey Скорость:
          span.info {{fields.speed}} км/ч
      div.tooltip__foot
</template>

<script>
import baseMapPopupMixin from './base-map-popup-mixin.js'

export default {
  name: 'map-popup-car',
  mixins: [baseMapPopupMixin],
  data() {
    this.closeCallback = null
    return {
      fields: {},
    }
  },
  computed: {
    lastUpdate() {
      if (this.fields.lastUpdate) {
        return this.$options.filters.unixTimeToDate(
          this.fields.lastUpdate,
          'YYYY.MM.DD в H:mm:ss'
        )
      }
      return '10.05.2018 в 8:30'
    },
  },
  methods: {
    update() {},
    injectConf(options) {
      let { model, closeCallback } = options
      this.closeCallback = closeCallback
      this.fields = Object.assign({}, model || {})
      this.registerVueInMap()
    },
    close($event) {
      this.closeCallback($event)
    },
  },
}
</script>
